import Icon from "@/v1-ui/Icon"
import { Tipover } from "@/v1-ui/Popover"
import useSidebarContext from "@/v1-ui/Sidebar/sidebar.context"
import { trackProjectsMenuShown }
  from "@/v1-console/project/selector/project.selector.tracking"

function AppSidebarProjectWarning() {
  const { isMini } = useSidebarContext()

  const content = (
    <span>
      Velg et{" "}
      <span
        className="link"
        onClick={() => {
          const el: HTMLElement = document.querySelector(".project-selector-selected")
          if (el) {
            el.click()
            trackProjectsMenuShown()
          }
        }}
      >
        prosjekt
      </span>
      {" "}for å aktivere funksjonene
    </span>
  )

  if (isMini) {
    return (
      <Tipover
        className="px-2 py-3 rounded-md bg-bg1 flex"
        placement="right"
        iconClassName="mx-auto"
        iconSrc="exclamation"
        iconSize={14}
        content={content}
      />
    )
  }

  return (
    <div className="p-2 text-sm leading-4 flex gap-1.5 rounded-md bg-bg1">
      <Icon
        className="mt-px"
        src="exclamation"
        size={14}
      />

      {content}
    </div>
  )
}

export default AppSidebarProjectWarning
